/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {MaterialBackIcon} from '../../icons/MaterialBackIcon';
import {dlsColor} from '../../theme/theme';
import {CTALink} from '../buttons/CTALink';
import navStyles from './Navigation.module.scss';

// defines the props for navigation switcher
export type NavigationSwitcherProps = {
  label: string;
  handleClick: () => void;
}

/**
 * @NavigationSwitcher
 *
 * Defines the NavigationSwitcher component. This component helps to switch to
 * primary navigation from secondary navigation in mobile. Should be rendered with
 * a custom label and a click event handler.
 *
 * ```typescript
 *
 *   <NavigationSwitcher label={}
 *     handleClick={} />
 *
 * ```
 */
export const NavigationSwitcher = ({
  label,
  handleClick
}: NavigationSwitcherProps) => (
  <div className={navStyles.toggleNavWrapper} onClick={handleClick}>
    <MaterialBackIcon color={dlsColor('white')} />
    <CTALink>{label}</CTALink>
  </div>
);

export default NavigationSwitcher;
